import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import StepCounter from "@/ui/core/StepCounter";
import type { StepCounterProps } from "@/ui/core/StepCounter";
import { Box } from "@/ui/layout";
import { ColorToken, LayoutToken } from "@/ui/theme/tokens";

const StoryMeta: Meta<StepCounterProps> = {
  title: "Core/Step Counter",
  component: StepCounter,
  argTypes: {
    currentStep: {
      control: { type: "number" },
    },
    totalSteps: {
      control: { type: "number" },
    },
  },
  args: {
    currentStep: faker.number.int({ max: 4, min: 1 }),
    totalSteps: 5,
  },
  render: (args) => (
    <Box
      backgroundColor={ColorToken.Primary10}
      paddingBottom={LayoutToken.OnboardingScreenHorizontalPadding}
      paddingHorizontal={LayoutToken.OnboardingScreenHorizontalPadding}
      paddingTop={LayoutToken.OnboardingScreenTopPadding}
      width="100%"
    >
      <StepCounter {...args} />
    </Box>
  ),
};

type Story = StoryObj<StepCounterProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
